import { Box, Grid, Collapse, Card } from "@mui/material";

import ActiveFilters from "../../../../Components/filters/ActiveFilters";
import FilterItems from "./FilterItems";

const Filter = ({
  filterOpen,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
}) => {
  const activeFilterDefinitions = [
    {
      type: "standard",
      id: "driverName",
      label: "Driver Name",
      value: submittedData.driverName,
    },
    {
      type: "standard",
      id: "userName",
      label: "User Name",
      value: submittedData.userName,
    },
    {
      type: "standard",
      id: "active",
      label: "Status",
      value: submittedData.active,
    },
  ];

  return (
    <>
      <Grid item xs={12} sx={{ mb: filterOpen ? 2 : 0 }}>
        <Collapse in={filterOpen}>
          <Card>
            <Box p={4}>
              <FilterItems
                filterData={filterData}
                handleChangeFilter={handleChangeFilter}
                handleFilter={handleFilter}
                handleClearFilters={handleClearFilters}
              />
            </Box>
          </Card>
        </Collapse>
      </Grid>

      <ActiveFilters
        filterDefinitions={activeFilterDefinitions}
        onRemoveFilter={handleRemove}
      />
    </>
  );
};

export default Filter;
